import { Box, BoxProps, Close, getVariant } from '@apia/theme';

type TLabelBoxVariant = 'normal' | 'selected';

export interface ILabelBox {
  className?: string;
  label: string;
  tooltip?: string;
  closeTooltip?: string;
  onClose?: () => unknown;
  variant?: TLabelBoxVariant;
}

type TLabelBox = ILabelBox & BoxProps;

export const LabelBox = ({
  className,
  label,
  tooltip,
  closeTooltip,
  onClose,
  variant,
  ...props
}: TLabelBox) => {
  return (
    <Box
      {...props}
      title={tooltip}
      className={`labelBox ${className ?? ''} ${variant || 'normal'}`}
      {...getVariant('layout.common.boxes.labelBox')}
    >
      <Box className="labelAndIcon" as="span">
        {label}
      </Box>
      {onClose && (
        <Box>
          <Close
            type="button"
            className="closeButton"
            onClick={onClose}
            title={closeTooltip}
            variant="icon-outline-danger"
          />
        </Box>
      )}
    </Box>
  );
};
